// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"445":"2c39a255","693":"6d62f832"}[chunkId] + ".css";
};